import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "mx-auto w-full max-w-7xl px-4 py-10 md:px-6" }
const _hoisted_2 = { class: "grid grid-cols-1 gap-8 md:grid-cols-[320px,1fr]" }
const _hoisted_3 = { class: "order-2 md:order-1 space-y-6" }
const _hoisted_4 = { class: "order-1 md:order-2" }
const _hoisted_5 = {
  key: 0,
  class: "space-y-6"
}
const _hoisted_6 = { class: "rounded-2xl border border-slate-200 bg-white" }
const _hoisted_7 = { class: "grid grid-cols-1 gap-4 border-t border-slate-200 p-5 md:grid-cols-2" }
const _hoisted_8 = { class: "mt-2" }
const _hoisted_9 = { class: "mt-2" }
const _hoisted_10 = {
  key: 0,
  class: "space-y-5"
}
const _hoisted_11 = {
  key: 1,
  class: "rounded-2xl border border-slate-200 bg-white p-10 text-center text-slate-600"
}
const _hoisted_12 = {
  key: 1,
  class: "space-y-6"
}
const _hoisted_13 = { class: "rounded-2xl border border-slate-200 bg-white" }
const _hoisted_14 = { class: "p-5" }
const _hoisted_15 = { class: "rounded-2xl border border-slate-200 bg-white" }
const _hoisted_16 = { class: "grid grid-cols-1 gap-0 border-t border-slate-200 md:grid-cols-2" }
const _hoisted_17 = { class: "flex flex-col gap-2 p-5" }
const _hoisted_18 = {
  key: 0,
  class: "text-red-600"
}
const _hoisted_19 = { class: "flex flex-col gap-2 border-t border-slate-200 p-5 md:border-l md:border-t-0" }
const _hoisted_20 = {
  key: 0,
  class: "text-red-600"
}
const _hoisted_21 = { class: "flex flex-col gap-2 border-t border-slate-200 p-5" }
const _hoisted_22 = {
  key: 0,
  class: "text-red-600"
}
const _hoisted_23 = { class: "flex flex-col gap-2 border-t border-slate-200 p-5 md:border-l" }
const _hoisted_24 = {
  key: 0,
  class: "text-red-600"
}
const _hoisted_25 = { class: "flex flex-col gap-2 border-t border-slate-200 p-5" }
const _hoisted_26 = { class: "flex flex-col gap-2 border-t border-slate-200 p-5 md:border-l" }

import { computed, onMounted, ref } from 'vue'
import { disableScroll, enableScroll, handleApiError, isValidEmail, resetErrors, saveBookingNumber } from '@/utils/common'
import { useRouter } from 'vue-router'
import Car from '@/composables/Car'
import { BookingStep, Car as CarType, UserSearch } from '@/types'
import CarResult from '@/components/CarResult.vue'
import { BOOKING_STEPS, LOADER_MINIMUM_TIME, PASSENGERS, SUITCASES } from '@/utils/constants'
import { retrieveUserSearch, saveUserTempSearch } from '@/services/search-service'
import BookingSummary from '@/components/BookingSummary.vue'
import Loader from '@/widgets/Loader.vue'
import Dropdown from '@/components/Dropdown.vue'
import CountrySearchablePhoneField from '@/components/CountrySearchablePhoneField.vue'
import BookingService from '@/services/booking-service'
import CarService from '@/services/car-service'


export default /*@__PURE__*/_defineComponent({
  __name: 'BookingLead',
  setup(__props) {

const { createBooking, updateBookingAsLead } = BookingService()
const { allCars }  = Car()
const router = useRouter()
const cars = ref<CarType[]>()
const selectedCar = ref<CarType>()
const showContactForm = ref<boolean>(false)
const passengers = PASSENGERS
const isLoading = ref<boolean>(false)
const suitcases = SUITCASES
const { saveSelectedCar }  = CarService()
const filters = ref<any>({
  passengers: null,
  doors: null,
  suitcases: null,
  transmission: null
})
const contactDetails = ref<any>({
  firstName: '',
  phoneNumber: '',
  flightNumber: '',
  lastName: '',
  email: '',
  comments: '',
  needConfirmation: false,
})
const errors = ref<any>({
  firstName: null,
  lastName: null,
  email: null,
  phoneNumber: null,
  responseError: null
})
const timeElapsed = ref<number>(0)
const steps = ref<BookingStep[]>(BOOKING_STEPS)
const currentStep = steps.value.filter((step) => step.uri === 'choose-vehicle')
const userSearch = ref<UserSearch>(retrieveUserSearch())

const handleCarSelected = (car: CarType) => {
  selectedCar.value = car
  // force visible price = 0 in the “lead” flow (kept from your original)
  // @ts-ignore
  selectedCar.value.price = 0
  showContactForm.value = true
  cars.value = [selectedCar.value as CarType]
}

/** Category rank for sorting:
 *  Premium (0) → Luxury (1) → SUV (2) → Van (3) → Others (99)
 *  Checks both car.type.name and car.name (case-insensitive).
 */
const categoryRank = (car: any): number => {
  const src = String(car?.type?.name || car?.name || '').toLowerCase()
  if (src.includes('premium')) return 0
  if (src.includes('luxury') || src.includes('lusary')) return 1
  if (src.includes('suv')) return 2
  if (src.includes('van')) return 3
  return 99
}

/** Final list: filter → sort by category → tie-break by passengers desc → then name asc */
const filteredCars = computed(() => {
  const list = (cars.value || []).filter((car: any) => {
    return (
      (!filters.value.passengers || (car?.type?.passengers ?? 0) >= filters.value.passengers) &&
      (!filters.value.doors || (car?.type?.doors ?? null) === filters.value.doors) &&
      (!filters.value.suitcases || (car?.type?.bags ?? 0) >= filters.value.suitcases) &&
      (!filters.value.transmission || (car?.transmission ?? '') === filters.value.transmission)
    )
  })

  return list.slice().sort((a: any, b: any) => {
    const ra = categoryRank(a)
    const rb = categoryRank(b)
    if (ra !== rb) return ra - rb

    // tie-break 1: more passengers first
    const paxA = Number(a?.type?.passengers ?? 0)
    const paxB = Number(b?.type?.passengers ?? 0)
    if (paxA !== paxB) return paxB - paxA

    // tie-break 2: name asc
    const na = String(a?.name || a?.type?.name || '')
    const nb = String(b?.name || b?.type?.name || '')
    return na.localeCompare(nb)
  })
})

const handleDropItemSelected = (item: any, name: string) => {
  const val = item?.value?.value === '' ? null : item?.value?.value
  if (name === 'passengers') filters.value.passengers = val
  else if (name === 'suitcases') filters.value.suitcases = val
  else if (name === 'doors') filters.value.doors = val
  else if (name === 'transmission') filters.value.transmission = val
}

const handleEditSearch = () => {
  saveUserTempSearch(userSearch.value)
  router.push({name: 'Home'})
}

const handlePhoneChange = (value: string) => {
  contactDetails.value.phoneNumber = value
}

const handleBookingProceed = async () => {
  resetErrors(errors.value)
  let isValid = validateForm()

  if (!isLoading.value && isValid) {
    if (!selectedCar.value) {
      console.log('Error in data collection')
      return
    }
    saveSelectedCar(selectedCar.value as CarType)
    isLoading.value = true
    const createResponse = await createBooking(selectedCar.value as CarType, userSearch.value as UserSearch)
    if (createResponse.success) {
      saveBookingNumber(createResponse.data.data.number)
      const updateResponse = await updateBookingAsLead(createResponse.data.data.number, contactDetails.value)
      if (updateResponse.success) {
        router.push({ name: 'BookingWizard', params: { step: 'finish' } })
      }
    }
  }
}

const validateForm = () => {
  let response = true

  if (contactDetails.value.firstName === '') {
    errors.value.firstName = true
    response = false
  }
  if (contactDetails.value.lastName === '') {
    errors.value.lastName = true
    response = false
  }
  if (contactDetails.value.phoneNumber === '') {
    errors.value.phoneNumber = 'Required'
    response = false
  } else if (contactDetails.value.phoneNumber.length < 11) {
    errors.value.phoneNumber = 'Invalid'
    response = false
  }
  if (contactDetails.value.email === '') {
    errors.value.email = 'Required'
    response = false
  } else if (!isValidEmail(contactDetails.value.email)) {
    errors.value.email = 'Invalid'
    response = false
  }
  return response
}

onMounted(async () => {
  isLoading.value = true
  disableScroll()
  const startTime = performance.now()
  const response = await allCars()
  timeElapsed.value = performance.now() - startTime
  if (timeElapsed.value < LOADER_MINIMUM_TIME) {
    const diff = LOADER_MINIMUM_TIME - timeElapsed.value
    setTimeout(() => {
      enableScroll()
      isLoading.value = false
    }, diff)
  } else {
    enableScroll()
    isLoading.value = false
  }

  if (response.status === 200) {
    cars.value = response.data.cars
  } else {
    handleApiError(response)
  }
})

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("aside", _hoisted_3, [
        _createVNode(BookingSummary, { currentStep: _unref(currentStep) }, null, 8, ["currentStep"]),
        _createElementVNode("button", {
          onClick: handleEditSearch,
          class: "flex w-full items-center justify-center gap-2 rounded-full border-2 border-slate-200 bg-slate-100 px-6 py-3 text-sm font-semibold text-slate-700 transition hover:bg-white"
        }, [
          _createVNode(_component_font_awesome_icon, {
            size: "lg",
            icon: "fa-solid fa-chevron-left"
          }),
          _cache[5] || (_cache[5] = _createTextVNode(" Edit search "))
        ])
      ]),
      _createElementVNode("section", _hoisted_4, [
        (!selectedCar.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _cache[8] || (_cache[8] = _createElementVNode("div", { class: "rounded-t-2xl bg-slate-100 px-5 py-3 text-xs font-semibold uppercase tracking-wide text-slate-600" }, " Filter your results ", -1)),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", null, [
                    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "text-[12px] font-medium text-slate-500 uppercase" }, "Passengers", -1)),
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(Dropdown, {
                        name: "passengers",
                        data: _unref(passengers),
                        onItem: handleDropItemSelected
                      }, null, 8, ["data"])
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "text-[12px] font-medium text-slate-500 uppercase" }, "Suitcases", -1)),
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(Dropdown, {
                        name: "suitcases",
                        data: _unref(suitcases),
                        onItem: handleDropItemSelected
                      }, null, 8, ["data"])
                    ])
                  ])
                ])
              ]),
              _createVNode(Loader, { show: isLoading.value }, null, 8, ["show"]),
              (!isLoading.value && filteredCars.value?.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredCars.value, (car, index) => {
                      return (_openBlock(), _createBlock(CarResult, {
                        key: index,
                        isLead: "1",
                        car: car,
                        canSelect: true,
                        selectedCar: selectedCar.value,
                        onSelected: handleCarSelected
                      }, null, 8, ["car", "selectedCar"]))
                    }), 128))
                  ]))
                : (!isLoading.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, " No cars match your filters. Try widening your selection. "))
                  : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _cache[9] || (_cache[9] = _createElementVNode("div", { class: "rounded-t-2xl bg-slate-100 px-5 py-3 text-xs font-semibold uppercase tracking-wide text-slate-600" }, " Your car ", -1)),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(CarResult, {
                    isLead: "1",
                    car: selectedCar.value,
                    canSelect: false,
                    selectedCar: selectedCar.value
                  }, null, 8, ["car", "selectedCar"])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _cache[16] || (_cache[16] = _createElementVNode("div", { class: "rounded-t-2xl bg-slate-100 px-5 py-3 text-xs font-semibold uppercase tracking-wide text-slate-600" }, " Guest contact details ", -1)),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("label", {
                      class: _normalizeClass([!errors.value.firstName ? 'text-slate-500' : 'text-red-600', "text-[12px] uppercase font-medium"])
                    }, [
                      _cache[10] || (_cache[10] = _createTextVNode(" First name * ")),
                      (errors.value.firstName)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_18, "(required)"))
                        : _createCommentVNode("", true)
                    ], 2),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((contactDetails.value.firstName) = $event)),
                      type: "text",
                      class: "h-10 w-full border-0 bg-transparent text-base font-semibold outline-none"
                    }, null, 512), [
                      [_vModelText, contactDetails.value.firstName]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("label", {
                      class: _normalizeClass([!errors.value.lastName ? 'text-slate-500' : 'text-red-600', "text-[12px] uppercase font-medium"])
                    }, [
                      _cache[11] || (_cache[11] = _createTextVNode(" Last name * ")),
                      (errors.value.lastName)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_20, "(required)"))
                        : _createCommentVNode("", true)
                    ], 2),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((contactDetails.value.lastName) = $event)),
                      type: "text",
                      class: "h-10 w-full border-0 bg-transparent text-base font-semibold outline-none"
                    }, null, 512), [
                      [_vModelText, contactDetails.value.lastName]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("label", {
                      class: _normalizeClass([!errors.value.email ? 'text-slate-500' : 'text-red-600', "text-[12px] uppercase font-medium"])
                    }, [
                      _cache[12] || (_cache[12] = _createTextVNode(" Email * ")),
                      (errors.value.email)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_22, "(" + _toDisplayString(errors.value.email) + ")", 1))
                        : _createCommentVNode("", true)
                    ], 2),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((contactDetails.value.email) = $event)),
                      type: "text",
                      class: "h-10 w-full border-0 bg-transparent text-base font-semibold outline-none"
                    }, null, 512), [
                      [_vModelText, contactDetails.value.email]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("label", {
                      class: _normalizeClass([!errors.value.phoneNumber ? 'text-slate-500' : 'text-red-600', "text-[12px] uppercase font-medium"])
                    }, [
                      _cache[13] || (_cache[13] = _createTextVNode(" Phone number * ")),
                      (errors.value.phoneNumber)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_24, "(" + _toDisplayString(errors.value.phoneNumber) + ")", 1))
                        : _createCommentVNode("", true)
                    ], 2),
                    _createVNode(CountrySearchablePhoneField, { onPhoneNumber: handlePhoneChange })
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _cache[14] || (_cache[14] = _createElementVNode("label", { class: "text-[12px] uppercase font-medium text-slate-500" }, "Flight number (optional)", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((contactDetails.value.flightNumber) = $event)),
                      type: "text",
                      class: "h-10 w-full border-0 bg-transparent text-base font-semibold outline-none"
                    }, null, 512), [
                      [_vModelText, contactDetails.value.flightNumber]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _cache[15] || (_cache[15] = _createElementVNode("label", { class: "text-[12px] uppercase font-medium text-slate-500" }, "No. of Pax , No of luggage , Child Seats, Special Requests ", -1)),
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((contactDetails.value.comments) = $event)),
                      class: "h-[60px] w-full resize-none border-0 bg-transparent text-base font-semibold outline-none"
                    }, null, 512), [
                      [_vModelText, contactDetails.value.comments]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("button", {
                onClick: handleBookingProceed,
                class: "group ml-auto flex w-full items-center justify-center gap-3 rounded-full border-2 border-slate-900 bg-slate-900 px-8 py-3 text-sm font-semibold text-white transition hover:bg-white hover:text-slate-900 md:w-auto"
              }, [
                _cache[17] || (_cache[17] = _createElementVNode("span", null, "Request a quote", -1)),
                _createVNode(_component_font_awesome_icon, {
                  class: "transition group-hover:translate-x-0.5",
                  size: "lg",
                  icon: "fa-solid fa-chevron-right"
                })
              ])
            ]))
      ])
    ])
  ]))
}
}

})